import React, { FC } from 'react';

import { useFormikContext } from 'formik';

import styled from 'styled-components';

import aampeTheme from '../../constants/aampeTheme';

import AccessMembers from './AccessMembers';
import EditorSelectionContainer from './EditorSelectionContainer';
import GroupUsersList from './GroupUsersList';
import { EntityPermissionUserFormikContext } from './constant';

interface ShareEditModalBodyProps {
    formulaId: number;
    hasWriteAccess: boolean;
}

const ShareEditModalBody: FC<ShareEditModalBodyProps> = ({
    formulaId,
    hasWriteAccess,
}) => {
    const { values } = useFormikContext<EntityPermissionUserFormikContext>();
    return (
        <>
            <Container>
                {!values.selectedGroup && (
                    <>
                        <EditorSelectionContainer
                            formulaId={formulaId}
                            hasWriteAccess={hasWriteAccess}
                        />
                        <AccessMembers />
                    </>
                )}
                {values.selectedGroup && (
                    <GroupUsersList
                        formulaId={formulaId}
                        hasWriteAccess={hasWriteAccess}
                    />
                )}
            </Container>
        </>
    );
};

const Container = styled.div({
    display: 'flex',
    flexDirection: 'column',
    padding: aampeTheme.spacing4(6),
    gap: aampeTheme.spacing4(6),
});

export default ShareEditModalBody;
